export function TrendingUpSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#2EB872"
        d="m16 6 2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
      ></path>
    </svg>
  );
}

export function TrendingDownSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      fill="none"
      viewBox="0 0 25 24"
    >
      <path
        fill="#FB6B7A"
        d="m16.333 18 2.29-2.29-4.88-4.88-4 4-7.41-7.42L3.743 6l6 6 4-4 6.3 6.29 2.29-2.29v6z"
      ></path>
    </svg>
  );
}

export function EggsSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      fill="none"
      viewBox="0 0 16 17"
    >
      <g stroke="#808487" clipPath="url(#clip0_184_1684)">
        <path
          strokeLinecap="round"
          d="M8 3.378c1.497-1.314 3.346-1.988 4.783-1.222 2.238 1.192 2.36 5.278 1.006 8.053-.568 1.166-1.32 1.908-2.161 2.29"
        ></path>
        <path d="M10 10.833c0 2.946-1.94 4.334-4.333 4.334s-4.334-1.388-4.334-4.334S3.191 4.5 5.667 4.5 10 7.888 10 10.833Z"></path>
      </g>
      <defs>
        <clipPath id="clip0_184_1684">
          <path fill="#fff" d="M0 .5h16v16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export function IncomingEggSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      fill="none"
      viewBox="0 0 25 24"
    >
      <path
        stroke="#D3907C"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M12.75 4.318c2.246-1.973 5.019-2.983 7.175-1.834 3.357 1.788 3.54 7.917 1.509 12.08-.853 1.749-1.98 2.861-3.242 3.436"
      ></path>
      <path
        stroke="#D3907C"
        strokeWidth="1.5"
        d="M15.75 15.5c0 4.418-2.91 6.5-6.5 6.5s-6.5-2.082-6.5-6.5S5.536 6 9.25 6s6.5 5.082 6.5 9.5Z"
      ></path>
      <path
        fill="#D3907C"
        stroke="#F9D4C9"
        d="M10.75 11.75V7.797l.124.145.079-.068a1.25 1.25 0 0 0 1.743-1.488l.08-.067-.325-.38-.325-.38-.35-.412-.325-.38-.009-.01-.028-.033-.066-.078-.222-.26-.002.003a5 5 0 0 0-.358-.364 2.1 2.1 0 0 0-.766-.45V3.5H9v.075a2.1 2.1 0 0 0-.766.45c-.119.106-.24.233-.357.364l-.003-.002-.224.262-.064.075-.025.03-.012.013-.324.38-.676.791-.324.38.079.068a1.25 1.25 0 0 0 1.743 1.488l.08.068.123-.145v4.453h.104a1.25 1.25 0 0 0 2.292 0h.104z"
      ></path>
    </svg>
  );
}

export function MilkCartonSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      fill="none"
      viewBox="0 0 17 17"
    >
      <path
        stroke="#808487"
        d="m2.838 5.35 1.829-1.183L6.495 5.35c.578.374.867.56 1.02.799.152.238.152.502.152 1.031v7.987h-2c-1.886 0-2.829 0-3.414-.38-.586-.378-.586-.988-.586-2.209V7.18c0-.529 0-.793.152-1.031s.441-.425 1.02-.8Z"
      ></path>
      <path
        stroke="#808487"
        strokeLinecap="round"
        d="M4.667 4.003v-.267c0-.816 0-1.224.293-1.477s.764-.254 1.707-.254h4.272c.543 0 1.248-.075 1.611.354.386.456.056 1.082.223 1.586.051.153.177.272.293.392L14.666 6"
      ></path>
      <path
        stroke="#808487"
        strokeLinejoin="round"
        d="M7.667 6.17h7v6.429c0 1.212 0 1.818-.41 2.194-.41.377-1.07.377-2.39.377h-4.2"
      ></path>
    </svg>
  );
}

export function ProductLoadingSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      fill="none"
      viewBox="0 0 25 24"
    >
      <path
        stroke="#8589CC"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M5.25 10.265V6h15v4.265c0 3.175 0 4.762-.976 5.749-.977.986-2.548.986-5.69.986h-1.667c-3.143 0-4.714 0-5.69-.986-.977-.986-.977-2.574-.977-5.749"
      ></path>
      <path
        stroke="#8589CC"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="m5.25 6 .721-1.538c.56-1.194.84-1.79 1.406-2.126C7.944 2 8.67 2 10.125 2h5.25c1.454 0 2.181 0 2.748.336s.847.932 1.406 2.126L20.25 6M11.25 9h3"
      ></path>
      <path
        stroke="#8589CC"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12.75 19.5V22m0-2.5h-5m5 0h5m-10 0h-2.5a2.5 2.5 0 0 0-2.5 2.5m5-2.5V22m10-2.5h2.5a2.5 2.5 0 0 1 2.5 2.5m-5-2.5V22"
      ></path>
    </svg>
  );
}

export function InvoiceSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      fill="none"
      viewBox="0 0 25 24"
    >
      <path
        stroke="#80BC60"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M4.333 18.646V8.054c0-2.854 0-4.28.879-5.167S7.505 2 10.333 2h4c2.829 0 4.243 0 5.122.887.878.886.878 2.313.878 5.167v10.592c0 1.511 0 2.267-.462 2.565-.755.486-1.921-.534-2.508-.904-.485-.306-.728-.458-.997-.467-.29-.01-.538.137-1.062.467l-1.91 1.205c-.516.325-.774.488-1.06.488s-.545-.163-1.06-.488l-1.911-1.205c-.485-.306-.728-.458-.997-.467-.29-.01-.538.137-1.062.467-.587.37-1.754 1.39-2.509.904-.462-.298-.462-1.053-.462-2.565M11.333 11h-3M14.333 7h-6"
      ></path>
    </svg>
  );
}

export function ClockSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      fill="none"
      viewBox="0 0 25 24"
    >
      <path
        stroke="#E6C536"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="m5.715 8.607-2.51-.153C5.003 3.704 10.17 1 15.205 2.344c5.365 1.433 8.551 6.917 7.117 12.25-1.434 5.332-6.945 8.494-12.31 7.061a10.04 10.04 0 0 1-7.346-8.17"
      ></path>
      <path
        stroke="#E6C536"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12.667 8v4l2 2"
      ></path>
    </svg>
  );
}

export function ArrowRightSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      fill="none"
      viewBox="0 0 8 14"
    >
      <path
        stroke="#B9B9B9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M1 1s6 4.419 6 6-6 6-6 6"
      ></path>
    </svg>
  );
}

export function ArrowLeftSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      fill="none"
      viewBox="0 0 8 14"
    >
      <path
        stroke="#B9B9B9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M7 1S1 5.419 1 7s6 6 6 6"
      ></path>
    </svg>
  );
}

export function TrashSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        stroke="#B9B9B9"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="m13 3.667-.268 4.337M3 3.667l.403 6.683c.103 1.711.155 2.567.583 3.183.211.304.484.56.8.754.448.273 1.001.355 1.88.38"
      ></path>
      <path
        stroke="#B9B9B9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="m13.333 10-4.666 4.666m4.666 0L8.667 10"
      ></path>
      <path
        stroke="#B9B9B9"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M14 3.667H2M10.705 3.667l-.455-.939c-.303-.624-.454-.935-.714-1.13a1.3 1.3 0 0 0-.184-.115c-.288-.15-.635-.15-1.328-.15-.71 0-1.066 0-1.36.157a1.3 1.3 0 0 0-.185.119c-.263.202-.41.526-.705 1.172l-.404.886"
      ></path>
    </svg>
  );
}

export function EditSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g
        stroke="#B9B9B9"
        strokeLinejoin="round"
        strokeWidth="1.5"
        clipPath="url(#clip0_670_825)"
      >
        <path d="M9.383 2.59c.496-.538.745-.807 1.009-.964a2.07 2.07 0 0 1 2.068-.031c.269.149.525.41 1.037.934.512.523.768.784.914 1.058.352.662.34 1.463-.03 2.114-.154.27-.418.523-.945 1.03L7.167 12.77c-.998.961-1.498 1.442-2.122 1.686s-1.31.226-2.681.19l-.187-.005c-.418-.01-.627-.016-.748-.154s-.105-.35-.072-.776l.018-.231c.094-1.197.14-1.796.374-2.334.234-.539.637-.976 1.444-1.85zM8.667 2.667l4.666 4.666"></path>
        <path strokeLinecap="round" d="M9.333 14.667h5.334"></path>
      </g>
      <defs>
        <clipPath id="clip0_670_825">
          <path fill="#fff" d="M0 0h16v16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export function TickDoubleSVG({ color = "#2EB872" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      fill="none"
      viewBox="0 0 25 24"
    >
      <path
        fill={color}
        d="M17.895 6.053a1 1 0 0 1-.447 1.342c-1.985.992-4.144 3.08-6 5.227a1 1 0 1 1-1.513-1.308c1.882-2.178 4.257-4.528 6.618-5.708a1 1 0 0 1 1.342.447M2.086 13.427a1 1 0 0 1 1.32-.508c.068.031.242.119.397.222.214.136.503.342.852.645.516.447 1.16 1.101 1.881 2.044a1 1 0 0 1 1.3 1.44 22 22 0 0 0-.45.697l-.02.035-.005.007a1.002 1.002 0 0 1-1.693.046c-.954-1.432-1.771-2.28-2.323-2.758a5 5 0 0 0-.616-.469 2 2 0 0 0-.15-.087 1 1 0 0 1-.493-1.314"
      ></path>
      <path
        fill={color}
        d="M22.895 6.053a1 1 0 0 1-.447 1.342c-2.294 1.146-4.804 3.745-6.8 6.177a58 58 0 0 0-3.073 4.118l-.177.265-.045.068-.01.016-.003.004a1 1 0 0 1-1.672.012c-.954-1.432-1.771-2.28-2.323-2.757a5 5 0 0 0-.616-.47 2 2 0 0 0-.15-.087 1 1 0 0 1 .827-1.821c.08.04.273.14.397.22.214.137.503.344.852.646.502.435 1.126 1.067 1.825 1.97l.143-.202a60 60 0 0 1 2.48-3.25c2.004-2.444 4.744-5.345 7.45-6.698a1 1 0 0 1 1.342.447"
      ></path>
    </svg>
  );
}

export function ArrowDownSVG({ color = "#09BBC9" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="m6 9.207 5.293 5.293c.333.333.5.5.707.5s.374-.167.707-.5L18 9.207"
      ></path>
    </svg>
  );
}

export function ArrowIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      fill="none"
      viewBox="0 0 12 6"
    >
      <path
        fill="#B9B9B9"
        d="M6 5.3a1.6 1.6 0 0 1-1.126-.467L1.07 1.03a.44.44 0 0 1 0-.618.44.44 0 0 1 .618 0l3.803 3.803c.28.28.735.28 1.015 0L10.31.412a.44.44 0 0 1 .619 0 .44.44 0 0 1 0 .618L7.126 4.833A1.6 1.6 0 0 1 6 5.3"
      ></path>
    </svg>
  );
}

export function IranIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="21"
      fill="none"
      viewBox="0 0 12 21"
    >
      <path
        fill="#484848"
        d="M3.177.693A4.2 4.2 0 0 1 4.282.68q.33.03.775.148.444.125.842.302.402.181.727.377l-.56.76a2 2 0 0 0-.249-.143 4.4 4.4 0 0 0-.846-.325 5 5 0 0 0-.531-.129 5 5 0 0 0-.722-.067q-.21 0-.407.029a1.8 1.8 0 0 0-.65.24 2 2 0 0 0-.364.276 1.8 1.8 0 0 0-.315.402q-.143.24-.23.555-.09.32-.09.727 0 .507.095.918c.095.411.158.515.282.722a1.83 1.83 0 0 0 1.048.837q.411.13.827.139h.057a4.5 4.5 0 0 0 1.454-.24q.335-.11.579-.22.249-.11.387-.195a1 1 0 0 0 .144-.086l.507.794-.206.12q-.177.105-.478.238-.296.14-.698.273a5 5 0 0 1-1.621.273q-.106 0-.412-.015-.31-.015-.827-.186A2.83 2.83 0 0 1 1.22 5.93q-.258-.435-.382-.966A4.8 4.8 0 0 1 .714 3.85q0-.611.153-1.148.149-.531.455-.947.3-.416.765-.693.465-.273 1.09-.369M7.09 4.84l-.78-.78.784-.784.78.78zm4.462 4.757a44 44 0 0 1-3.482.244 58 58 0 0 1-2.616 0 21 21 0 0 1-1.497-.077l.053-.942a45 45 0 0 0 1.96.1 30 30 0 0 0 1.612-.004 60 60 0 0 0 3.826-.258zM4.33 13.494q-.626 0-1.196-.268a4.3 4.3 0 0 1-1.057-.712 6 6 0 0 1-.899-1.01 9 9 0 0 1-.708-1.171l.847-.412q.177.345.392.684.21.34.454.641t.517.555q.268.253.564.426.297.176.617.263a1.8 1.8 0 0 0 .646.052q.273-.033.583-.105.316-.067.617-.148a25 25 0 0 0 1.01-.301l.277.899q-.555.18-.947.354-.387.171-.636.353a1.3 1.3 0 0 0-.359.378.87.87 0 0 0-.115.44v.077H4v-.082q0-.066.005-.172a1.15 1.15 0 0 1 .143-.492 1 1 0 0 1 .201-.249zm.607.815v.923q0 .277.01.54.014.263.072.488t.167.397a.77.77 0 0 0 .316.268 1 1 0 0 0 .253.072q.1.014.215.014a2.3 2.3 0 0 0 .536-.072q.225-.052.469-.153l1.023-.416.421.851q-.005 0-.1.043-.09.044-.249.11a7 7 0 0 1-.808.306 5.4 5.4 0 0 1-1.225.25 2 2 0 0 1-.153.004q-.435 0-.765-.144a1.6 1.6 0 0 1-.54-.382 1.9 1.9 0 0 1-.345-.54 2.7 2.7 0 0 1-.181-.675A5 5 0 0 1 4 15.437V14.31h.937zm-2.5 1.664-.776-.775.78-.784.78.775zm-.006 1.96-.78-.774.785-.784.775.774-.78.785zm9.12 2.16a44 44 0 0 1-3.481.243 58 58 0 0 1-2.616 0 21 21 0 0 1-1.497-.076l.053-.943q1.07.077 1.96.1a30 30 0 0 0 1.612-.004 60 60 0 0 0 3.826-.258z"
      ></path>
    </svg>
  );
}
